import { useTranslation } from 'next-i18next';

import EmptyState from '@/components/common/EmptyState';
import { useAppSelector } from '@/redux';

import styles from './PaymentPending.module.scss';
import { PAYMENT_PLATFORMS } from '@/constants/checkout';

export const PaymentPending = () => {
  const { t } = useTranslation();
  const action = useAppSelector(({ cart }) => cart.content.paiementMode.action);

  const paragraph = action === PAYMENT_PLATFORMS.NO_VALIDATION ?
    'message.paymentInProgressDesc.withNoValidation' : 'message.paymentInProgressDesc.withValidation';

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <EmptyState
          illustration={{ url: '/static/spinner.gif', alt: 'loader' }}
          title={t('message.paymentInProgress')}
          paragraph={t(paragraph)}
        />
      </div>
    </div>
  );
};

export default PaymentPending;
